import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useCallback, useRef, useMemo, useEffect } from "react";
import { parseUnits } from "ethers/lib/utils";
import { useQuicksellCartContext } from "./QuickSellProvider";
import { QuicksellStatusModal } from "./QuicksellStatusModal";
import useAcceptBidCart from "./useAcceptBidCart";
export const MultiChainAcceptBidManager = ({ bids, onCompleted, }) => {
    const [activeChain, setActiveChain] = useState(0);
    const quicksellFunctions = useRef({});
    const { dispatch } = useQuicksellCartContext();
    const [error, setError] = useState(false);
    const chainGroups = useMemo(() => {
        return bids.reduce((acc, bid) => {
            acc[bid.chainId] = acc[bid.chainId] || [];
            acc[bid.chainId].push(bid);
            return acc;
        }, {});
    }, [bids]);
    const chainEntries = Object.entries(chainGroups);
    const handleListAll = useCallback(async () => {
        var _a, _b;
        dispatch({ type: "SET_TRANSACTION_RUNNING", payload: true });
        for (const [chainId] of chainEntries) {
            const numericChainId = Number(chainId);
            setActiveChain(numericChainId);
            try {
                await ((_b = (_a = quicksellFunctions.current)[numericChainId]) === null || _b === void 0 ? void 0 : _b.call(_a));
            }
            catch (error) {
                console.log("error", error);
                dispatch({
                    type: "SET_ERROR",
                    payload: { chainId: Number(chainId), error: error },
                });
                setError(true);
                setActiveChain(0);
                break;
            }
        }
        onCompleted();
        if (!error) {
            dispatch({ type: "SET_FINISHED" });
            setActiveChain(0);
        }
    }, [chainGroups]);
    useEffect(() => {
        if (handleListAll) {
            dispatch({ type: "START_TRANSACTION", payload: handleListAll });
        }
    }, [handleListAll]);
    const chainTokens = useMemo(() => Object.entries(chainGroups).map(([chainId, chainTokens]) => (_jsx(ChainAcceptBidCart, { chainId: Number(chainId), bids: chainTokens, registerLister: (fn) => {
            quicksellFunctions.current[Number(chainId)] = fn;
        } }, chainId))), [chainGroups, activeChain]);
    return (_jsxs(_Fragment, { children: [_jsx(QuicksellStatusModal, { activeChain: activeChain, chainEntries: chainEntries }), chainTokens] }));
};
const ChainAcceptBidCart = ({ chainId, bids, registerLister, }) => {
    const tokens = bids
        .filter((bid) => bid.tokenId)
        .map((bid) => {
        var _a;
        return ({
            tokenId: (_a = bid.tokenId) !== null && _a !== void 0 ? _a : "",
            collectionId: bid.address,
            quantity: bid.quantity,
            bidIds: [bid.reservoirId],
            royaltyBps: bid.royaltyBps,
        });
    });
    const feesOnTopCustom = (orders) => {
        const fees = orders === null || orders === void 0 ? void 0 : orders.filter((order) => {
            return !!bids.find((bid) => { var _a; return bid.reservoirId.toLowerCase() === ((_a = order.orderId) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
        }).reduce((listOfFees, order) => {
            const bid = bids.find((bid) => { var _a; return bid.reservoirId.toLowerCase() === ((_a = order.orderId) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
            const rawWeiPrice = order.totalRawPrice || "0";
            const customRoyalty = bid.royaltyBps;
            const weiRoyalty = parseUnits(rawWeiPrice, 0)
                .mul(customRoyalty)
                .div(10000);
            const royaltyAddress = bid.royaltyRecipient;
            if (!royaltyAddress || !weiRoyalty || weiRoyalty.isZero()) {
                return listOfFees;
            }
            return [...listOfFees, `${royaltyAddress}:${weiRoyalty.toString()}`];
        }, []);
        return fees;
    };
    const { acceptBid } = useAcceptBidCart({ tokens, chainId, feesOnTopCustom });
    useEffect(() => {
        registerLister(acceptBid);
    }, [acceptBid, registerLister]);
    return _jsx(_Fragment, {});
};
